// App.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';

import AuthPage from './components/AuthPage/AuthPage'; // 新增的登录注册页面
import Unit from './components/unit/Unit';
import Paper from './components/paper/Paper';
import DecimalGrid from './components/DecimalGrid/DecimalGrid';
import MatchingGame from './components/MatchingGame/MatchingGame';
import { useNavigate } from 'react-router-dom';
import { setNavigate } from './utils/navigateService';
import VerticalCalc from "./components/VerticalCalc/VerticalCalc";
import DiyImage from "./components/DiyImage/DiyImage";
import DiyImageShow from "./components/DiyImageShow/DiyImageShow";
import WrongAnswerReview from "./components/WrongAnswerReview/WrongAnswerReview";

const savedData = {"type":"diy_image","shapes":[{"type":"ellipse","id":"E1","center":{"x":141,"y":101},"rx":59,"ry":40.11234224026316,"style":"solid"},{"type":"ellipse","id":"E2","center":{"x":139,"y":116},"rx":42.1070065428546,"ry":16.0312195418814,"style":"solid"},{"type":"ellipse","id":"E3","center":{"x":139,"y":121},"rx":39.11521443121589,"ry":20.09975124224178,"style":"solid"},{"type":"circle","id":"O1","center":{"x":182,"y":41},"radius":40,"style":"solid"}],"svgWidth":320,"svgHeight":240,"cellSize":20}

function App() {
    const navigate = useNavigate();

    // 初始化全局导航
    setNavigate(navigate);

    return (
        <Routes>
            {/* 登录注册页面 */}
            <Route path="/" element={<AuthPage />} />

            {/* 其他页面 */}
            <Route path="/unit" element={<Unit />} />
            <Route path="/paper" element={<Paper />} />
            <Route path="/wrongReview" element={<WrongAnswerReview />} />
            <Route path="/grid100" element={<DecimalGrid gridType="100" filledCount={15} gridModify={true} />} />
            <Route path="/grid10" element={<DecimalGrid gridType="10" filledCount={2} gridModify={true} />} />
            <Route path="/matchingGame" element={<MatchingGame />} />
            <Route path="/diyImage" element={<DiyImage />} />
            <Route path="/diyImageShow" element={<DiyImageShow savedData={savedData} showGrid={false}/> } />
            <Route path="/verticalCalc" element={<VerticalCalc dataMatrix={[
                ["","1","#{1}",".","3",""],
                ["+", "", "#{2}",".","#{2}","2"],
                "line",
                ["","1","A",".","0","2"],
                "line",
                ["+", "", "4",".","#{2}","2"]
            ]}/>} />
        </Routes>
    );
}

export default App;
